import * as React from 'react';
import { Button } from '../../../../commonv3/components/atoms/buttons/Button';
import './reservationCompletePane.module.scss';
import { ReservationPane } from '../../atoms/reservations/ReservationPane';
import { CancellationPolicy } from './CancellationPolicy';
import { isMulticreatorSession } from '../../organisms/mypage/ReservationListPane';
import { Reservable } from '../../../../commonv3/types/reservable';

type Props = {
    onCompleteClick: () => any;
    reservable: Reservable;
};

export class ReservationCompletePane extends React.Component<Props> {
    render() {
        const { onCompleteClick, reservable } = this.props;
        return (
            <ReservationPane id="complete-session-reservation-pane" styleName="pane">
                <div styleName="text">予約が完了しました</div>
                <div styleName="date">メニューの「予約したもの」から予約内容を確認できます。</div>
                {!isMulticreatorSession(reservable) && <CancellationPolicy />}
                <div styleName="button-wrapper">
                    <Button styleName="button" type="primary" size="m" disabled={false} onClick={onCompleteClick}>
                        マイページへ戻る
                    </Button>
                </div>
            </ReservationPane>
        );
    }
}
